import {
  GetOrgScimStatusRequest,
  GetOrgScimStatusResponse,
} from "@safetyculture/s12-apis-connect-web/s12/tools/support/v1/support_pb";

import { supportServiceConnectClient } from "../index";
import { RequestMetadata } from "api/types";

export type OrgScimData = {
  status?: GetOrgScimStatusResponse;
  loadFailed: boolean;
};

export const getOrgScimStatus = async (
  { orgId }: { orgId: string },
  headers: Record<RequestMetadata, string>,
): Promise<GetOrgScimStatusResponse> => {
  const req = new GetOrgScimStatusRequest({ orgId });
  return supportServiceConnectClient.getOrgScimStatus(req, { headers });
};
